import { DropMnemonicIdFilter } from 'root/src/client/v2/battlePass/constants';
export const defaultDropFilter = {
    mnemonicId: DropMnemonicIdFilter.All,
    campaignName: 'ALL',
    id: DropMnemonicIdFilter.All,
};
